/**
 * Checks if the current page is a quiz
 *
 * @return {Boolean} True if current page is a quiz
 */
export const isQuiz = () => {
	return isDefined( document.querySelector( '.wpProQuiz_content' ) );
};

/**
 * Invokes callback when DOM is ready
 *
 * @param {Function} callback The callback
 */
export const onReady = ( callback ) => {
	// If the document isn't ready yet, add the event listener
	// eslint-disable-next-line @wordpress/no-global-event-listener
	document.addEventListener( 'DOMContentLoaded', callback );

	// If it's already loaded, invoke
	if ( document.readyState === 'interactive' || document.readyState === 'complete' ) {
		callback();
	}
};

/**
 * Determines if a variable is set and is not NULL
 *
 * @param {mixed} variable - The variable being evaluated
 * @return {boolean}    TRUE if the variable is defined
 */
export const isDefined = ( variable ) => {
	// Returns true if the variable is undefined
	return typeof variable !== 'undefined' && variable !== null;
};

/**
 * Determines whether a variable is empty
 *
 * @param {mixed} variable - The variable being evaluated
 * @return  {boolean}   TRUE if the variable is empty
 */
export const isEmpty = ( variable ) => {
	let response = true;

	// Check if the variable is defined, otherwise is empty
	if ( isDefined( variable ) ) {
		// Check if it's array
		if ( Array.isArray( variable ) ) {
			response = variable.length == 0;
		} else if ( isObject( variable ) ) {
			response = Object.keys( variable ).length == 0;
		} else {
			response = variable == '';
		}
	}

	return response;
};

/**
 * Find whether a variable is an object
 *
 * @param {mixed} variable - The variable being evaluated
 * @return  {boolean}   TRUE if the variable is an object
 */
export const isObject = ( variable ) => {
	return variable !== null && typeof variable === 'object';
};

/**
 * Returns the value of a parameter in the URL
 *
 * @param {String} url       The URL
 * @param {String} parameter The parameter key
 * @return {String}           The parameter value
 */
export const getURLParameter = ( url = '', parameter = '' ) => {
	// If the URL is empty, use the site URL
	if ( isEmpty( url ) ) {
		url = window.location.href;
	}

	// Convert it to an URL object
	url = new URL( url );

	// Get parameter
	return url.searchParams.get( parameter );
};

/**
 * Creates a new function that limits calls to func to once every given timeframe.
 *
 * @param {Function} func     The function
 * @param {Integer}  interval The inverval, in ms
 * @return {Function} The function
 */
export const throttle = ( func, interval ) => {
	let lastCall = 0;

	// eslint-disable-next-line space-before-function-paren
	return function () {
		const now = Date.now();
		if ( lastCall + interval < now ) {
			lastCall = now;
			return func.apply( this, arguments );
		}
	};
};
